export default __webpack_public_path__ + "static/media/frank.80ab1b5a.jpg";